const EventMyWorkChange = function(uid,data) {
    this.data = data;
    this.uid = uid;
};

EventMyWorkChange.prototype.validate = function() {
    return true;
};

EventMyWorkChange.prototype.process = function() {
    if (!gd.session.myWork) return;

    try {
        const myWork = gd.session.myWork.get(this.data.id);

        if (myWork) {
            myWork.reset(this.data);
            gd.session.myWork.trigger("reset");
            gd.session.myWork.folder(myWork.folder).trigger("reset");
            gd.bus.triggerEvent('gd.session.myWork:reset');

            if(gd.session.assignedTasks && gd.session.assignedTasks.planning && myWork.task) {
                const assignedTask = gd.session.assignedTasks.getTask(myWork.task.id);
                if (assignedTask) {
                    assignedTask.scheduleStatus = myWork.task.scheduleStatus;
                    assignedTask.scheduleDate = myWork.task.scheduleDate;
                }
            }

            // temporary solution for new my work (for dateCreated, isNew and fromUserId)
            if (this.data.task) {
                gd.modelBus.newUpdate('my-work-task', 'delta', this.data.task.id, _.assign({}, this.data.task, {
                    properties: {
                        'myWork'    : {
                            'actionRequired': {
                                sinceMoment : this.data.dateCreated,
                                isNew       : this.data.isNew,
                                fromUserId  : this.data.fromUserId,
                            }
                        }
                    }
                }), {
                    task        : this.data.task,
                    isBulkUpdate: true,
                })
            }
        }
    } catch(err) {
        gd.utils.captureErrorMessage('EventMyWorkChange error', {
            level: 'error', // one of 'info', 'warning', or 'error'
            extra: {
                this: this,
                error: err,
            }
        });
    }
};


module.exports = EventMyWorkChange;

